import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form';
import { FieldError } from './FieldError';
import { formatNI } from './utils';

interface Props<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
}

export const NIInput = <T extends FieldValues>({ name, control, label }: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });
  return (
    <div>
      {label && <label className="lbl">{label}</label>}
      <input
        ref={field.ref}
        name={field.name}
        value={(field.value as string) ?? ''}
        onChange={(e) => field.onChange(formatNI(e.target.value))}
        onBlur={field.onBlur}
        placeholder="AB 12 34 56 C"
        maxLength={13}
        className={`inp uppercase ${error ? 'inp-error' : ''}`}
        aria-invalid={!!error}
      />
      <FieldError message={error?.message} />
    </div>
  );
};
